module.exports = __webpack_public_path__ + "static/media/service-finance-company-logo.165de268.png";